import {WindowEvents} from "../../global/kendoWindows";
import {showErrorNotification} from "../../global/notifications";

let k_deleteWindow;

export default function () {
    createWindow();
    WindowEvents.onOpenEvents.RevProjManualEntryDeleteConf = function () {
        const $window = this.element;
        const data = $window.data();
        k_deleteWindow.title(`Delete ${data.entryId}?`)
        $window.find('.js-entry-id').text(data.entryId);
        const $yes = $window.find('button.k-primary');

        if ($yes.length) {
            $yes.unbind('click');
            $yes.bind('click', function () {
                deleteEntry(data.entryId)
                    .then(_ => $('#projectionId').change())
                    .catch(error => showErrorNotification(error));
            });
        }
    }
}

const createWindow = () => {
    let $window = $("#RevProjManualEntryDeleteConf");
    if ($window.length) return;
    const window = '<div id="RevProjManualEntryDeleteConf"><div><p>Are you sure you want to delete <span class="js-entry-id"></span>?</p></div><div><button class="k-button k-primary" style="margin: 20px;">Yes</button><button class="k-button k-red">No</button></div></div>'
    $('#content').append(window);
    k_deleteWindow = $("#RevProjManualEntryDeleteConf").kendoWindow({
        title: '',
        visible: false,
        actions: [
            'Close'
        ]
    }).data('kendoWindow');

    bindNoButton();
}

const bindNoButton = () => {
    let $window = $("#RevProjManualEntryDeleteConf");
    const $no = $window.find('button.k-red');
    if ($no.length) {
        $no.unbind('click');
        $no.bind('click', function () {
            k_deleteWindow.close();
        })
    }
}

const deleteEntry = (entryId) => {
    return new Promise((resolve, reject) => {
        const data = {
            pid: $('[name=pid]').val(),
            mid: $('[name=mid]').val(),
            entryId: entryId
        }
        $.post('/Forms/ProjectReview/DeleteManualRevenueProjection', data, function (response) {
            if (response && response.success) resolve();
            else reject("Failed to delete entry.")
        })

    })
}